const React = require('react');
const InputUploadA = require('../A');
const Empty = require('./Empty');
const LoadingItem = require('./LoadingItem');
const ReuploadItem = require('./ReuploadItem');


module.exports = (props) => {
  return (
    <InputUploadA
      componentEmpty={Empty}
      componentLoadingItem={LoadingItem}
      componentReuploadItem={ReuploadItem}
      {...props}
    />
  );
};
